import { render, staticRenderFns } from "./ContainerItem.vue?vue&type=template&id=877bab96&scoped=true&"
import script from "./ContainerItem.vue?vue&type=script&lang=js&"
export * from "./ContainerItem.vue?vue&type=script&lang=js&"
import style0 from "./ContainerItem.vue?vue&type=style&index=0&id=877bab96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877bab96",
  null
  
)

export default component.exports